<template>
<svg viewBox="0 0 48 48" :fill="useCurrentColor ? 'currentColor' : '#000'" :class="[`${prefix}-icon`, `${prefix}-icon-exit-rich-text`]" width="1em" height="1em" v-bind="$attrs"><path fill-rule="evenodd" clip-rule="evenodd" d="M18 28a2 2 0 012 2v13a1 1 0 01-1 1h-2a1 1 0 01-1-1V32H5a1 1 0 01-1-1v-2a1 1 0 011-1h13zM31 4a1 1 0 011 1v11h11a1 1 0 011 1v2a1 1 0 01-1 1H30a2 2 0 01-2-2V5a1 1 0 011-1h2z"/></svg>
</template>
<script>

export default {
  name: 'IconExitRichText',
  props: {
    prefix: {
        type: String,
        default: 'arco',
    },
    useCurrentColor: {
        type: Boolean,
        default: true,
    },
  },
};
</script>
